const COMMENTS = [
  {
    name: '漫迷小明',
    avatar: '明',
    time: '3天前',
    content: '在歪歪漫画网追了半年了，更新速度真的快！韩漫那边的资源比其他站全太多，下拉式阅读体验也很舒服，躺着就能一直往下看，完全不用手动翻页。',
    likes: '128',
    comic: '反派千金的重生逆袭',
  },
  {
    name: '二次元的猫',
    avatar: '猫',
    time: '5天前',
    content: '国漫专区做得越来越好了，灵笼和剑尊归来都在追。每日更新的漫画数量是真的多，再也不用到处找资源了。希望以后多加点日漫经典老番。',
    likes: '96',
    comic: '剑尊归来之无双天下',
  },
  {
    name: '深夜追更人',
    avatar: '夜',
    time: '1周前',
    content: '作为一个重度漫画爱好者，歪歪漫画网简直就是我的快乐老家。分类清晰、更新及时、阅读流畅，而且全免费！安利给了好多朋友，都说好用。',
    likes: '203',
    comic: '社内恋爱禁止令',
  },
  {
    name: '漫画收藏家',
    avatar: '藏',
    time: '2周前',
    content: '用了大半年了，漫画资源确实丰富，韩漫日漫国漫都有。唯一的建议是希望增加一些完结经典作品的合集推荐，有时候想补老番不太好找。',
    likes: '74',
    comic: '异世界悠闲 farming 生活',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          读者热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          听听漫画同好们怎么说
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/80"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold font-heading flex-shrink-0">
                  {comment.avatar}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">
                    {comment.time} · 在 <span className="text-primary-500">{comment.comic}</span> 下评论
                  </p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-primary-400"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}